import mapNavitationItemsToMenuUrl from '@/lib/mappers/mapNavigationItemsToMenus';
import { FfbbsiteNavigation } from '../../directus';

export function formatHeaderFooterData(headerFooterData: FfbbsiteNavigation[] | undefined) {
  let headerMainMenus: Array<any> = [];
  let headerMainRightMenus: Array<any> = [];
  let headerTopLeftMenus: Array<any> = [];
  let headerTopRightMenus: Array<any> = [];

  headerFooterData?.forEach(({ location, items }) => {
    switch (location) {
      case 'main':
        headerMainMenus = mapNavitationItemsToMenuUrl(items);
        break;
      case 'main-right':
        headerMainRightMenus = mapNavitationItemsToMenuUrl(items);
        break;
      case 'top-left':
        headerTopLeftMenus = mapNavitationItemsToMenuUrl(items);
        break;
      case 'top-right':
        headerTopRightMenus = mapNavitationItemsToMenuUrl(items);
        break;
    }
  });

  let topMenus = headerTopLeftMenus;
  let outils = headerTopRightMenus.filter((menu) => menu.label?.toLowerCase() === 'mes outils');
  if (outils.length > 0) {
    topMenus = topMenus.concat(outils);
  }

  return {
    leftMenus: headerMainMenus,
    rightMenus: headerMainRightMenus,
    topMenus,
  };
}
